// extracted by mini-css-extract-plugin
export default {"storyItem":"c-a_eA","storyItem__circle":"c-a_eB","storyItem__image":"c-a_eC","storyItem__description":"c-a_eE","storyItem_viewAll":"c-a_eF"};